module.exports = __webpack_public_path__ + "57c336b6.webp";